import { useEffect, useState } from "react";
import RequestModal from "../modals/RequestModal";
import { url } from "../utils/config";
import axios from "axios";
import AddLocation from "../modals/AddLocation";
import LocationMap from "./LocationMap";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnOne, btnSmall, btnSmallTwo, inputStyle, title } from "../utils/style";

function Locations() {

    const [locations, setLocations] = useState([]);
    const [specialEquipments, setSpecialEquipments] = useState([]);
    const [hubEquipments, setHubEquipments] = useState([]);
    const [showRequestModal, setShowRequestModal] = useState(false);
    const [locationIndex, setLocationIndex] = useState(0)
    const [showSpokeEquipments, setShowSpokeEquipments] = useState(false);
    const [spokeEquipments, setSpokeEquipments] = useState([]);
    const [spokeId, setSpokeId] = useState(null);
    const [locationType, setLocationType] = useState();
    const [showAddLocation, setShowAddLocation] = useState(false);
    const [showMap, setShowMap] = useState(false);
    const [reloadTable, setReloadTable] = useState(false)

    useEffect(() => { fetchLocations() }, [reloadTable])

    // useEffect(() => {
    //     if(window.location.search.includes('code')) {
    //         setShowAddLocation(true)
    //     }
    // }, [])

    async function fetchLocations() {
        try {
            const reqUrl = url + '/locations';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            console.log(data);
            setLocations(data.locations);
            setHubEquipments(data.equipmentItems);
            setSpecialEquipments(data.specialEquipments);
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    async function fetchSpokeEquipments(id) {
        try {
            setSpokeId(id);
            const reqUrl = url + '/spoke_equipments/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            console.log(data);
            setSpokeEquipments(data.data)
            setShowSpokeEquipments(true);
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    async function authorizeQb() {
        try {
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const redirectUri = `${window.location.origin}/inventory/locations`
            const data = await axios.post(url + '/qb_auth_url', { redirectUri }, { headers })
            console.log(data.data.data)

            window.location.replace(data.data.data);
            // setShowAddLocation(true)
        } catch (error) {
            console.log(error)
        }
    }


    return (
        <div className="p-4">
            {
                showRequestModal &&
                <RequestModal
                    setShowModal={setShowRequestModal}
                    equipments={specialEquipments}
                    locationType={locationType}
                    location_id={locationType === 'Hub' ? locations[locationIndex]['id'] : spokeId}
                />
            }
            {
                showAddLocation && <AddLocation setShowModal={setShowAddLocation} reload={setReloadTable} />
            }
            <div className="">
                <div className={title}>Locations</div>
            </div>
            <div className="flex gap-12">
                <div className="basis-1/2">
                    <div className="flex justify-between items-center">
                        <div className="font-semibold text-sm">Parent Hub</div>
                        <span>
                            <Button className={btnOne} name={'Add New Location'} clickHandler={() => setShowAddLocation(true)} />
                            {/* <Button className={btnOne} name={'Show On Map'} clickHandler={() => setShowMap(true)} /> */}
                        </span>
                    </div>

                    <div className="py-2">
                        <select data-testid='hub' className={inputStyle} onChange={e => setLocationIndex(e.target.value)}>
                            {
                                locations.map((l, i) => <option key={i} value={i} >{l.name}</option>)
                            }
                        </select>
                    </div>

                    {
                        locations.length !== 0 &&
                        <LocationMap
                            setShowModal={setShowMap}
                            locations={locations[locationIndex]}
                            className={'w-full py-2 rounded-md'}
                        />
                    }

                    <div className="">
                        <div className="font-semibold text-sm py-4">Spokes Under this Hub</div>
                        {
                            locations.length > 0 && locations[locationIndex].spokes.map((s, i) =>
                                <div key={i} className="text-xs px-2 py-4 flex rounded-lg shadow-md mb-3 items-center">
                                    <div className="flex-1">
                                        <div>{s.name}</div>
                                        <div>{s.address}</div>
                                    </div>
                                    <div className="text-right">
                                        <button className={'text-xs text-customOne'} onClick={() => fetchSpokeEquipments(s.id)}>{'View Equipment >'}</button>
                                    </div>
                                </div>)
                        }
                    </div>
                </div>
                <div className="basis-1/2">
                    <div className="">
                        {
                            locations.length > 0 &&
                            <div className="col-span-2">
                                <div className="font-semibold text-sm">Additional Information</div>
                                <div className="">
                                    <span className="font-semibold mr-4 text-xs">Address:</span>
                                    <span className="text-xs">{locations[locationIndex].address || ''}</span>
                                </div>
                                <div className="">
                                    <span className="font-semibold mr-4 text-xs">Contact Person:</span>
                                    <span className="text-xs ">{locations[locationIndex].contactPerson || ''}</span>
                                </div>
                                <div className="">
                                    <span className="font-semibold mr-2 text-xs">Inventory Capacity: </span>
                                    <span className="text-xs">{locations[locationIndex].inventoryCapacity || ''}</span>
                                </div>
                                <div className="flex justify-between py-4 items-center">
                                    <div className="font-semibold text-sm">In-Stock Items:</div>
                                    <div className="text-center">
                                        <Button className={btnOne} name={'Request'} clickHandler={() => { setLocationType('Hub'); setShowRequestModal(true) }} />
                                    </div>
                                </div>
                                <div className="">
                                    {
                                        specialEquipments.length > 0 &&
                                        <div className="grid grid-cols-3 bg-gray-200 py-2 border border-gray-300 rounded-md shadow-sm">
                                            <div className="col-span-2 font-semibold text-sm text-center">In-Stock Item</div>
                                            <div className="col-span-1 font-semibold text-sm text-center">Quantity</div>
                                        </div>
                                    }
                                    {
                                        specialEquipments.map((se, ind) =>
                                            <div className="grid grid-cols-3 py-2 border border-gray-300 rounded-md bg-white shadow-sm hover:bg-gray-50 transition duration-200" key={ind}>
                                                <div className="col-span-2 text-sm text-center">{se.name}</div>
                                                <div className="col-span-1 text-sm text-center">
                                                    <span className="ml-2">
                                                        {hubEquipments.filter(eq => eq.location_id === locations[locationIndex]['id'] && eq.special_equipment_id === se.id).length}
                                                    </span>
                                                </div>
                                            </div>
                                        )

                                    }

                                </div>
                            </div>
                        }
                    </div>
                    <div className='mt-8'>
                        {
                            showSpokeEquipments &&
                            <div className="px-3">
                                <div className="flex justify-between items-center py-4">
                                    <div className="font-semibold text-sm">Special Equipment</div>
                                    <div className="text-center py-2">
                                        <Button className={btnOne} name={'Request'} clickHandler={() => { setLocationType('Spoke'); setShowRequestModal(true) }} />
                                    </div>
                                </div>
                                {
                                    showSpokeEquipments &&
                                    <div className="grid grid-cols-3 py-2 bg-gray-200 border border-gray-300 rounded-md shadow-sm">
                                        <div className="col-span-2 font-semibold text-sm text-center">In-Stock Items</div>
                                        <div className="col-span-1 font-semibold text-sm text-center">Quantity</div>
                                    </div>
                                }
                                {
                                    specialEquipments.map((se, ind) =>
                                        <div key={ind} className="grid grid-cols-3 py-2 border border-gray-300 rounded-md bg-white shadow-sm hover:bg-gray-50 transition duration-200">
                                            <span className="col-span-2 text-sm text-center">{se.name}</span>
                                            <span className="col-span-1 text-sm text-center">
                                                {spokeEquipments.filter(eq => eq.special_equipment_id === se.id).length}
                                            </span>
                                        </div>
                                    )
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Locations;